import { defineStore } from "pinia";
import { showError } from "src/utils/notify";
import { sortListingByDate } from "src/utils/dateHelper";
import { Buffer } from "buffer";

export const useMfg = defineStore("mfg", {
  state: () => ({
    mfgs: [],
    loadMfg: false,
    mfgsDeals: [],
    loadmfgsDeals: false,
    mfgDetails: {},
    loadmfgDetails: false,
    findmfgs: [],
    loadfindMfg: false,

    earningHistory: [],
    loadEarningHistory: false,
    groupedHistoryData: {},
    loadmfgsCoupons: false,
    mfgsCoupons: [],
  }),
  getters: {},
  actions: {
    setDataToMfg(mfg) {
      this.mfgDetails = mfg;
      this.loadmfgDetails = true;
    },
    async getMyMfg() {
      try {
        this.loadMfg = false;
        this.mfgs = [];
        let data = await this.$request.post(this.apiEndpoints.MY_MFG, {
          enforce_age_restrictions: 1,
        });
        if (data.data) {
          this.mfgs = data.data.items;
          this.loadMfg = true;
        }
      } catch (error) {}
    },
    resetMfg() {
      this.mfgs = [];
      this.loadMfg = false;
    },
    async getMyMfgDeals(manufacturerid, params = "") {
      try {
        this.loadmfgsDeals = false;
        this.mfgsDeals = [];
        let data = await this.$request.get(
          this.apiEndpoints.MFG_DEALS(manufacturerid) + params
        );
        if (data.data) {
          this.mfgsDeals = data.data.items ? data.data.items : [];
          this.loadmfgsDeals = true;
        }
      } catch (error) {}
    },
    resetmfgDeals() {
      this.mfgsDeals = [];
      this.loadmfgsDeals = false;
    },
    resetmfgDetails() {
      this.mfgDetails = {};
      this.loadmfgDetails = false;
    },
    async getFindMfgDetails(manufacturerid) {
      try {
        this.mfgDetails = {};
        this.loadmfgDetails = false;
        let data = await this.$request.get(
          this.apiEndpoints.FIND_MFG_DETAILS(manufacturerid)
        );
        if (data.data) {
          this.mfgDetails = data.data.items;
          this.loadmfgDetails = true;
        }
      } catch (error) {}
    },
    async getMfgDetails(manufacturerid) {
      try {
        this.mfgDetails = {};
        this.loadmfgDetails = false;
        let data = await this.$request.get(
          this.apiEndpoints.MFG_DETAILS(manufacturerid)
        );
        if (data.data) {
          this.mfgDetails = data.data.items;
          this.loadmfgDetails = true;
        }
      } catch (error) {}
    },
    async getfindMfg() {
      try {
        this.findmfgs = [];
        this.loadfindMfg = false;
        let data = await this.$request.get(this.apiEndpoints.FIND_MFG, {
          enforce_age_restrictions: 1,
        });
        if (data?.data && data?.data?.items) {
          this.findmfgs = data.data.items;
        }
        this.loadfindMfg = true;
      } catch (error) {}
    },
    async updateMfgSetting(manufacturerid, params) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.MFG_PREFS(manufacturerid),
          params
        );
        if (data.data) {
          return data.data;
        }
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    async getEarningHistory(params) {
      if (params.page == 1) {
        this.earningHistory = [];
        this.groupedHistoryData = {};
        this.loadEarningHistory = false;
      }
      try {
        let response = await this.$request.get(
          this.apiEndpoints.EARNING_HISTORY_MFG(
            params.store_id,
            params.page,
            params.per_page,
            params.campaign_id
          )
        );
        if (response.data) {
          Array.prototype.push.apply(this.earningHistory, response.data.items);
          const historyData = JSON.parse(
            JSON.stringify(this.groupedHistoryData)
          );
          const sortData = sortListingByDate(response.data.items || []);
          for (let date in sortData) {
            if (date in historyData)
              historyData[date] = [...historyData[date], ...sortData[date]];
            else historyData[date] = sortData[date];
          }
          this.groupedHistoryData = historyData;
          this.loadEarningHistory = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetEarningHistory() {
      this.earningHistory = [];
      this.groupedHistoryData = {};
      this.loadEarningHistory = false;
    },
    async getMyMfgCoupns(manufacturerid) {
      try {
        this.loadmfgsCoupons = false;
        this.mfgsCoupons = [];
        let data = await this.$request.get(
          this.apiEndpoints.MFG_COUPONS(manufacturerid)
        );
        if (data.data) {
          this.mfgsCoupons = data.data.items;
          this.loadmfgsCoupons = true;
        }
      } catch (error) {}
    },
    async downloadImage(url) {
      try {
        var base64 = await this.$request
          .get(url, {
            responseType: "arraybuffer",
          })
          .then((response) =>
            Buffer.from(response.data, "binary").toString("base64")
          );
        if (base64) {
          return "data:image/jpeg;base64, " + base64;
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
  },
});
